module.exports = __webpack_public_path__ + "img/invalidObject.5d1aeee2.svg";